module.exports = __webpack_public_path__ + "static/media/YF64_2.78c623be.jpg";